import {h, Fragment} from "preact"
import { useFacet, useAppState } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import Icon from "../elements/Icon";
import FacetPanel from './FacetPanel'
import { slugify } from '../../utils'

export default function FacetColor({ facet }) {
    const { toggleProductFilter } = useFacet(facet);
    const { query } = useAppState();
    const [activeSelect, setActiveSelect] = useState(true);
    const [showAll, setShowAll] = useState(false); 
    const [locationSplit, setLocationSplit] = useState(location.pathname.split('/')); 
    // const initialVisibleCount = 10; 

    
    // const visibleItems = showAll ? facet.data : facet.data?.slice(0, initialVisibleCount);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 768px)");
    
        const handleMediaChange = (e) => {
            setActiveSelect(e.matches);
        };
    
        handleMediaChange(mediaQuery);
    
        mediaQuery.addEventListener("change", handleMediaChange);
    
        return () => {
            mediaQuery.removeEventListener("change", handleMediaChange);
        };
    }, []);


    return (
        <FacetPanel 
            className="facet-color"
            panelName={facet.name} 
            showMoreButton={false}>
                    {facet.data?.map((value) => (
                        <div
                            className="item-color"
                            data-nosto-element="facet-setting"
                        >

                            <button 
                                ariaLabel={`Color ${value.value}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleProductFilter(facet.field, value.value, !value.selected);
                                }}
                                className={`btn-filter-color filter-color-${slugify(value.value)} ${value.selected ? 'active' : ''}`}
                                ></button>
                        </div>
                    ))}
        </FacetPanel>
    );
}
